import type { ComponentProps } from "react";

import LoadingSpinner from "~/assets/svg/loading-spinner.svg?react";

import { useCssVariable } from "./use-css-variable";

export function ThemedLoadingSpinner(props: ComponentProps<typeof LoadingSpinner>) {
  const color = useCssVariable("--primary");
  return <LoadingSpinner color={color} {...props} />;
}
